import { Component } from "react"
import PropTypes from "prop-types"
import Result from "./result"
import { TextField, Paper } from "@mui/material"
import "./style.scss"

class Autocomplete extends Component {
  static propTypes = {
    search: PropTypes.func.isRequired,
    selectItem: PropTypes.func.isRequired,
    searchResults: PropTypes.array,
    value: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
  }

  onChange = event => {
    const { value } = event.target
    const { search } = this.props
    search(value)
  }

  renderResults() {
    const { searchResults, selectItem, value } = this.props

    if (searchResults.length === 0 && value) {
      return <Paper className="results" square>
        <div className="result-item no-results">No results...</div>
      </Paper>
    } else if (searchResults.length > 0 && value) {
      return <Paper className="results" square>
        {searchResults.map((item, i) => <Result key={i} item={item} onClick={selectItem} />)}
      </Paper>
    }
  }

  render() {
    const { searchResults, value, autoFocus, disabled, label, placeholder } = this.props

    return <div className="components_autocomplete">
      <TextField
        variant="standard"
        label={label}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        type="search"
        fullWidth
        value={value || ""}
        onChange={this.onChange}
      />
      {searchResults && this.renderResults()}
    </div>
  }
}

export default Autocomplete
